import React, { useEffect, useRef, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const SocialProofSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef?.current) {
      observer?.observe(sectionRef?.current);
    }

    return () => observer?.disconnect();
  }, []);

  const clients = [
  { name: 'Газпром', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
  { name: 'Сбербанк', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
  { name: 'Яндекс', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
  { name: 'МТС', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
  { name: 'Ростелеком', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
  { name: 'Магнит', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' }];


  const testimonials = [
  {
    name: 'Алексей Петров',
    position: 'Директор по продажам',
    company: 'ООО "ТехноПром"',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bf927f41-1763294628249.png",
    avatarAlt: 'Professional headshot of middle-aged Russian businessman with short dark hair wearing navy blue suit and white shirt',
    quote: 'СФЕРА полностью изменила наш подход к работе с клиентами. За 6 месяцев мы увеличили конверсию на 45% и сократили время обработки заявок в 3 раза. ИИ-ассистент Виктория стала незаменимым помощником для всей команды.',
    metrics: { revenue: '+45%', time: '-67%', satisfaction: '9.2/10' },
    linkedin: 'https://linkedin.com'
  },
  {
    name: 'Мария Соколова',
    position: 'Генеральный директор',
    company: 'АО "МегаСтрой"',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1dec45867-1763296601115.png",
    avatarAlt: 'Professional headshot of confident Russian businesswoman with blonde hair in elegant black blazer',
    quote: 'Мы перепробовали множество CRM-систем, но только СФЕРА смогла объединить все наши процессы в одной платформе. Особенно впечатлила возможность создавать кастомные модули под специфику строительного бизнеса.',
    metrics: { revenue: '+38%', time: '-55%', satisfaction: '9.5/10' },
    linkedin: 'https://linkedin.com'
  },
  {
    name: 'Дмитрий Иванов',
    position: 'IT-директор',
    company: 'ГК "Логистика+"',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c5942421-1763295562537.png",
    avatarAlt: 'Professional headshot of experienced Russian IT director with glasses and gray hair in dark suit',
    quote: 'Интеграция СФЕРА с нашими существующими системами прошла безболезненно. Техподдержка работает на высшем уровне. За год работы не было ни одного критического сбоя. ROI окупился за 4 месяца.',
    metrics: { revenue: '+52%', time: '-72%', satisfaction: '9.8/10' },
    linkedin: 'https://linkedin.com'
  }];


  const certifications = [
  { name: 'SOC 2 Type II', icon: 'Shield', description: 'Сертификация безопасности' },
  { name: 'GDPR', icon: 'Lock', description: 'Соответствие GDPR' },
  { name: 'ISO 27001', icon: 'Award', description: 'Информационная безопасность' },
  { name: 'ФЗ-152', icon: 'FileCheck', description: 'Защита персональных данных' }];


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials?.length);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="clients" ref={sectionRef} className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-card via-background to-card" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-4xl sm:text-5xl font-black text-foreground mb-4">
            Нам доверяют лидеры рынка
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            500+ компаний уже трансформировали свой бизнес с СФЕРА
          </p>
        </div>

        <div className={`glassmorphism rounded-2xl p-8 mb-12 transition-all duration-1000 delay-200 ${
        isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`
        }>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {clients?.map((client, index) =>
            <div
              key={index}
              className="flex items-center justify-center p-4 glassmorphism rounded-lg hover:scale-110 transition-transform duration-300">

                <div className="text-center">
                  <div className="w-16 h-16 mx-auto mb-2 rounded-lg bg-muted/20 flex items-center justify-center">
                    <Icon name="Building2" size={32} color="var(--color-muted-foreground)" />
                  </div>
                  <span className="text-xs text-muted-foreground font-medium">{client?.name}</span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={`glassmorphism-strong rounded-2xl p-8 mb-12 transition-all duration-1000 delay-400 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`
        }>
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="lg:w-1/3">
              <div className="relative">
                <div className="w-48 h-48 mx-auto rounded-2xl overflow-hidden border-4 border-primary/20">
                  <Image
                    src={testimonials?.[currentTestimonial]?.avatar}
                    alt={testimonials?.[currentTestimonial]?.avatarAlt}
                    className="w-full h-full object-cover" />

                </div>
                <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 glassmorphism px-4 py-2 rounded-full border border-primary/20">
                  <div className="flex items-center space-x-2">
                    <Icon name="Linkedin" size={16} color="var(--color-primary)" />
                    <span className="text-xs text-primary font-medium">Подтверждено</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:w-2/3">
              <div className="mb-4">
                <Icon name="Quote" size={40} color="var(--color-primary)" className="mb-4" />
                <p className="text-lg text-foreground mb-6 leading-relaxed">
                  {testimonials?.[currentTestimonial]?.quote}
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-xl font-bold text-foreground">
                  {testimonials?.[currentTestimonial]?.name}
                </h4>
                <p className="text-sm text-muted-foreground">
                  {testimonials?.[currentTestimonial]?.position} • {testimonials?.[currentTestimonial]?.company}
                </p>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="glassmorphism rounded-lg p-4 text-center">
                  <div className="text-2xl font-bold text-primary mb-1">
                    {testimonials?.[currentTestimonial]?.metrics?.revenue}
                  </div>
                  <div className="text-xs text-muted-foreground">Рост выручки</div>
                </div>
                <div className="glassmorphism rounded-lg p-4 text-center">
                  <div className="text-2xl font-bold text-accent mb-1">
                    {testimonials?.[currentTestimonial]?.metrics?.time}
                  </div>
                  <div className="text-xs text-muted-foreground">Экономия времени</div>
                </div>
                <div className="glassmorphism rounded-lg p-4 text-center">
                  <div className="text-2xl font-bold text-secondary mb-1">
                    {testimonials?.[currentTestimonial]?.metrics?.satisfaction}
                  </div>
                  <div className="text-xs text-muted-foreground">Удовлетворенность</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center space-x-2 mt-8">
            {testimonials?.map((_, index) =>
            <button
              key={index}
              onClick={() => setCurrentTestimonial(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
              currentTestimonial === index ? 'w-8 bg-primary' : 'bg-muted-foreground/30'}`
              } />

            )}
          </div>
        </div>

        <div className={`grid grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-1000 delay-600 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`
        }>
          {certifications?.map((cert, index) =>
          <div key={index} className="glassmorphism rounded-xl p-6 text-center hover:scale-105 transition-transform duration-300">
              <div className="w-16 h-16 mx-auto mb-4 rounded-xl bg-success/10 flex items-center justify-center">
                <Icon name={cert?.icon} size={32} color="var(--color-success)" />
              </div>
              <h4 className="font-bold text-foreground mb-1">{cert?.name}</h4>
              <p className="text-xs text-muted-foreground">{cert?.description}</p>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default SocialProofSection;